import React from 'react';
import { Link } from 'react-router-dom';
import './ResourceCenter.css';

const ResourceCenter: React.FC = () => {
  const resourceCategories = [
    {
      title: 'Estate',
      icon: '🏛️',
      description: 'Estate planning resources and guidance',
      articles: [
        'Understanding Estate Planning Basics',
        'Creating a Will vs. Trust',
        'Estate Tax Planning Strategies',
        'Powers of Attorney Explained'
      ]
    },
    {
      title: 'Insurance',
      icon: '🛡️',
      description: 'Insurance and protection planning information',
      articles: [
        'Life Insurance Needs Analysis',
        'Disability Insurance Essentials',
        'Long-Term Care Planning',
        'Umbrella Insurance Coverage'
      ]
    },
    {
      title: 'Investment',
      icon: '📈',
      description: 'Investment strategies and market insights',
      articles: [
        'Asset Allocation Strategies',
        'Understanding Market Volatility',
        'Diversification Benefits',
        'Investment Risk Management'
      ]
    },
    {
      title: 'Lifestyle',
      icon: '🌟',
      description: 'Financial planning for life events',
      articles: [
        'Buying Your First Home',
        'Financial Planning for Marriage',
        'Managing Finances During Divorce',
        'Planning for Major Purchases'
      ]
    },
    {
      title: 'Money',
      icon: '💰',
      description: 'Money management and budgeting tips',
      articles: [
        'Creating a Household Budget',
        'Emergency Fund Planning',
        'Debt Management Strategies',
        'Cash Flow Optimization'
      ]
    },
    {
      title: 'Retirement',
      icon: '🏖️',
      description: 'Retirement planning and income strategies',
      articles: [
        'Retirement Savings Strategies',
        'Social Security Optimization',
        'Medicare Planning Guide',
        'Retirement Income Distribution'
      ]
    },
    {
      title: 'Tax',
      icon: '📊',
      description: 'Tax planning and strategies',
      articles: [
        'Year-End Tax Planning',
        'Tax-Efficient Investing',
        'Retirement Account Tax Benefits',
        'Tax Loss Harvesting'
      ]
    }
  ];

  return (
    <div className="resource-center">
      {/* Hero Section */}
      <section className="resource-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Resource Center</h1>
            <p className="hero-subtitle">
              Access our comprehensive library of financial articles, guides, and resources 
              to help you make informed decisions about your financial future.
            </p>
          </div>
        </div>
      </section>

      {/* Resource Categories */}
      <section className="section resource-categories">
        <div className="container">
          <h2 className="section-title">Browse by Category</h2>
          <div className="grid grid-cols-3">
            {resourceCategories.map((category, index) => (
              <div key={index} className="resource-category-card">
                <div className="category-icon">{category.icon}</div>
                <h3>{category.title}</h3>
                <p className="category-description">{category.description}</p>
                <ul className="article-list">
                  {category.articles.map((article, articleIndex) => (
                    <li key={articleIndex}>
                      <button 
                        className="article-link" 
                        onClick={() => alert(`${article} - Coming soon!`)}
                      >
                        {article}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="category-action">
                  <button 
                    className="btn btn-secondary"
                    onClick={() => alert(`${category.title} articles - Coming soon!`)}
                  >
                    View All Articles
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Resources */}
      <section className="section section-alt featured-resources">
        <div className="container">
          <h2 className="section-title">Featured Resources</h2>
          <div className="grid grid-cols-2">
            <div className="featured-resource">
              <div className="resource-image">
                <div className="image-placeholder">
                  <span>📚</span>
                </div>
              </div>
              <div className="resource-content">
                <h3>Financial Planning Guide</h3>
                <p>
                  Our comprehensive guide to creating and maintaining a financial plan 
                  that adapts to your changing life circumstances.
                </p>
                <Link to="/contact" className="btn btn-primary">Download Guide</Link>
              </div>
            </div>
            <div className="featured-resource">
              <div className="resource-image">
                <div className="image-placeholder">
                  <span>📊</span>
                </div>
              </div>
              <div className="resource-content">
                <h3>Market Outlook Report</h3>
                <p>
                  Stay informed with our quarterly market analysis and economic outlook 
                  to help guide your investment decisions.
                </p>
                <Link to="/contact" className="btn btn-primary">Read Report</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="section newsletter-signup">
        <div className="container">
          <div className="newsletter-content">
            <h2>Stay Informed</h2>
            <p>
              Subscribe to our newsletter to receive the latest financial insights, 
              market updates, and planning strategies delivered to your inbox.
            </p>
            <form className="newsletter-form">
              <div className="form-group">
                <input 
                  type="email" 
                  placeholder="Enter your email address" 
                  className="email-input"
                  required
                />
                <button type="submit" className="btn btn-primary">Subscribe</button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="section resource-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Need Personalized Guidance?</h2>
            <p>
              While our resources provide valuable information, personalized financial planning 
              requires individual attention. Contact us to discuss your specific situation.
            </p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Schedule a Consultation
              </Link>
              <Link to="/services" className="btn btn-secondary">
                View Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResourceCenter; 